import {Injectable} from "@angular/core";
import {NativeDateAdapter} from "@angular/material/core";
import {environment} from "../../environments/environment";


@Injectable()
export class CustomNativeDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === "string" && value.length > 0) {
      const trimmed = value.trim();

      // 1. ISO 8601 support: '2025-05-10'
      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        const isoDate = new Date(trimmed);
        if (!isNaN(isoDate.getTime())) {
          return isoDate;
        }
      }
      const parts = trimmed.split(/[\/\-.]/);
      if (parts.length === 3) {
        let day: number, month: number, year: number;

        // Pas parsing volgorde aan op taal
        if (environment.language === "nl") {
          // Verwacht: dd-MM-yyyy
          [day, month, year] = parts.map(Number);
        } else {
          // Verwacht: MM/dd/yyyy
          [month, day, year] = parts.map(Number);
        }

        if (year < 100) {
          year += 2000;
        }
        month -= 1; // JS Date expects 0-based month

        if (
          day > 0 && day <= 31 &&
          month >= 0 && month <= 11 &&
          year >= 1900 && year <= 2100
        ) {
          return new Date(year, month, day);
        }
      }
    }

    return super.parse(value);
  }

  override format(date: Date, displayFormat: Object): string {
    const lang = environment.language || "en";

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return lang === "nl"
      ? `${day}-${month}-${year}`      // 10-05-2025
      : `${month}/${day}/${year}`;     // 05/10/2025
  }
}
